__turbopack_context__.v({
  "backgroundColor": "VYuJbG_backgroundColor",
  "backgroundColorMobile": "VYuJbG_backgroundColorMobile",
  "defaqtoBg": "VYuJbG_defaqtoBg",
  "selectBtn": "VYuJbG_selectBtn",
  "whichBadge": "VYuJbG_whichBadge",
  "whichBadgeContainer": "VYuJbG_whichBadgeContainer",
  "whichBadgeContainerPriceToggle": "VYuJbG_whichBadgeContainerPriceToggle",
  "whichBadgeContainerSelected": "VYuJbG_whichBadgeContainerSelected",
});
